import { useEffect, useRef } from "react"

/**
 * @callback UseFixedContainedBgImage
 * @param {number} imgNaturalWidth
 * @param {number} imgNaturalHeight
 * @param {number} [displayHeightPerc]
 * @param {number} [bgPosYPerc]
 * @param {number} [bgPosYOffset]
 * @return {React.MutableRefObject<HTMLElement>}
 */

/** @type {UseFixedContainedBgImage} */
export const useFixedContainedBgImage = (
    imgNaturalWidth,
    imgNaturalHeight,
    displayHeightPerc = 100,
    bgPosYPerc = 0
) => {
    const elemRef = useRef(/** @type {HTMLElement} */(null))

    useEffect(() => {
        const elem = /**  */ (elemRef.current)

        function onWindowSizeChange() {
            const height = (imgNaturalHeight / imgNaturalWidth * elem.clientWidth)
            elem.style.height = displayHeightPerc / 100 * height + "px"
            elem.style.backgroundPositionY = elemRef.current.offsetTop + (bgPosYPerc / 100 * height) + "px"

            if (height >= document.documentElement.clientHeight)
                elem.style.backgroundSize = "cover"
            else if (elem.style.backgroundSize !== "contain")
                elem.style.backgroundSize = "contain"
        }

        window.addEventListener("resize", onWindowSizeChange)
        onWindowSizeChange()

        return () => window.removeEventListener("resize", onWindowSizeChange)
    }, [imgNaturalWidth, imgNaturalHeight, displayHeightPerc, bgPosYPerc])

    return elemRef
}